import { Box, Button, ClickAwayListener, debounce, Fab, IconButton, InputAdornment, Menu, MenuItem, Stack, Tab, TextField, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';
import { TodoState, VovClient } from '../../../ApiOld/ApiServerVov';
import MobileRequestsDetailTab, { IMobileRequestsDetailTabRef } from './MobileRequestsDetailTab';
import { AddCircle, AddOutlined, ChevronRight, Search } from '@mui/icons-material';
import MobileRequestCreateDialog from './MobileRequestCreateDialog';
import { useRef } from 'react';
import MobileRequestsTabLabel from './Components/MobileRequestsTabLabel';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';

export interface IMobileRequestsTabsProps {
}

export default function MobileRequestsTabs(props: IMobileRequestsTabsProps) {
    const { setModuleButton, setModuleName, setModuleSecondButton, setUnreadMessages } = useEmployeeContext();
    const [createTaskOpen, setCreateTaskOpen] = React.useState(false);
    const detailTabRefNew = useRef<IMobileRequestsDetailTabRef>(null);
    const detailTabRefActive = useRef<IMobileRequestsDetailTabRef>(null);
    const detailTabRefResolved = useRef<IMobileRequestsDetailTabRef>(null);

    const { authorizedMobileEmployeeApi } = useMobileApi(VovClient);

    const [newUnreadCount, setNewUnreadCount] = React.useState(0);
    const [activeUnreadCount, setActiveUnreadCount] = React.useState(0);
    const [resolvedUnreadCount, setResolvedUnreadCount] = React.useState(0);
    const { t } = useTranslation();

    React.useEffect(() => {
        authorizedMobileEmployeeApi.getUnreadMessagesCount().then((res) => {
            setNewUnreadCount(res.newUnreadMessages ?? 0);
            setActiveUnreadCount(res.activeUnreadMessages ?? 0);
            setResolvedUnreadCount(res.resolvedUnreadMessages ?? 0);
            setUnreadMessages((res.newUnreadMessages ?? 0) + (res.activeUnreadMessages ?? 0) + (res.resolvedUnreadMessages ?? 0));
        });
    }, [authorizedMobileEmployeeApi, setUnreadMessages]);

    React.useEffect(() => {
        setModuleButton && setModuleButton(null);
        setModuleSecondButton && setModuleSecondButton(null);
    }, [setModuleButton, setModuleName, t, setModuleSecondButton]);

    const [value, setValue] = React.useState('1');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const refreshTab = () => {
        switch (value) {
            case '1':
                detailTabRefNew.current?.refreshData();
                break;
            case '2':
                detailTabRefActive.current?.refreshData();
                break;
            case '3':
                detailTabRefResolved.current?.refreshData();
                break;
        }
    }



    return (
        <Box sx={{ width: '100%', typography: 'body1', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 56px)' }}>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="mobile-attendance-tabs"
                        sx={{
                            backgroundColor: '#FFC600',
                            color: 'black',
                            '& .Mui-selected': {
                                color: 'black!important',
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'black',
                            },
                        }}>
                        <Tab label={<MobileRequestsTabLabel title={t('New')} unreadMessageCount={newUnreadCount} />} value="1" sx={{ flex: 1 }} />
                        <Tab label={<MobileRequestsTabLabel title={t('beingResolved')} unreadMessageCount={activeUnreadCount} />} value="2" sx={{ flex: 1 }} />
                        <Tab label={<MobileRequestsTabLabel title={t('resolved')} unreadMessageCount={resolvedUnreadCount} />} value="3" sx={{ flex: 1 }} />
                    </TabList>
                </Box>
                <Box sx={{ flex: 1, overflowY: 'auto' }}>
                    <TabPanel value="1">
                        <MobileRequestsDetailTab setUnreadCount={(n) => setNewUnreadCount(n)} ref={detailTabRefNew} state={TodoState.NEW} />
                    </TabPanel>
                    <TabPanel value="2">
                        <MobileRequestsDetailTab setUnreadCount={(n) => setActiveUnreadCount(n)} ref={detailTabRefActive} state={TodoState.ACTIVE} />
                    </TabPanel>
                    <TabPanel value="3">
                        <MobileRequestsDetailTab setUnreadCount={(n) => setResolvedUnreadCount(n)} ref={detailTabRefResolved} state={TodoState.RESOLVED} />
                    </TabPanel>
                </Box>
            </TabContext>
            <Box
                sx={{
                    position: "fixed",
                    bottom: 16,
                    left: 0,
                    right: 0,
                    display: "flex",
                    justifyContent: "center",
                    zIndex: 1000, // Ensures it appears on top
                }}
            >
                {/* <Fab
                    // variant="contained"
                    // startIcon={<AddOutlined />}
                    // endIcon={<ChevronRight />}
                    // sx={{
                    //     backgroundColor: "#FFC600",
                    //     color: "black",
                    //     fontWeight: "bold",
                    //     width: "90%",
                    //     maxWidth: "400px",
                    //     borderRadius: "25px",
                    //     boxShadow: "1px"
                    // }}
                    onClick={() => setCreateTaskOpen(true)}
                >
                    {t("createNewTask")}
                    {/* <Box display="flex" justifyContent="space-between" width="100%">
                        <Typography variant='body1' fontWeight={'bold'}>{t("createNewTask")}</Typography>
                        <ChevronRight />
                    </Box> 
                </Fab> */}
                <Fab
                    onClick={() => { setCreateTaskOpen(true) }}
                    color="primary" aria-label="add" sx={{ position: 'fixed', bottom: 16, right: 16 }}>
                    <AddCircle />
                </Fab>
                <MobileRequestCreateDialog open={createTaskOpen} onClose={(refresh) => { setCreateTaskOpen(false); if (refresh) refreshTab(); }} />
            </Box>
        </Box>);
}
